<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.pension')}}
    Icon(icon="pension" classes="p-title__icon")
  Ownership(risk="pension" risk_object="saving_long_term")
  Ownership(risk="pension" risk_object="pension_saving")
  Ownership(risk="pension" risk_object="pension_private" v-if="shouldInsurePensionComplementaryForIndependent")
  Ownership(risk="pension" risk_object="pension_complementary_for_independent" v-if="shouldInsurePensionComplementaryForIndependent")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  },
  computed: {
    shouldInsurePensionComplementaryForIndependent () {
      return this.$store.getters.isIndependent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Pension.vue